import { LayerTypeId } from "../generated/enums"
import { groupBy } from "../utils/array"
import { isObject } from "../utils/utils"
import { IDataLayerType, IDatalayerViewerFactory, IDatalayerViewManager } from "./types"

export class DatalayerViewManagerProvider implements ng.IServiceProvider {

    private _viewers: IDatalayerViewerFactory[] = [];

    register(viewers: IDatalayerViewerFactory[]) {
        this._viewers = this._viewers.concat(viewers);
    }

    $get() {

        return new DatalayerViewManager(this._viewers);

    }
}

interface ViewManagerItem {
    current: IDatalayerViewerFactory;
    viewers: IDatalayerViewerFactory[]
};

export class DatalayerViewManager implements IDatalayerViewManager {

    private _viewers: { [key: number]: ViewManagerItem } = {};

    constructor(viewers: IDatalayerViewerFactory[]) {

        var groups = groupBy(viewers, v => v.typeId);


        groups.forEach(i => {

            this._viewers[i.key] = {
                viewers: i.values,
                current: i.values[0]
            }

        });

    }

    private getItem(type: IDataLayerType | LayerTypeId): ViewManagerItem {
        var typeId = <number>(isObject(type) ? (<IDataLayerType>type).TypeId : type);
        return this._viewers[typeId];

    }

    getViewers(type: LayerTypeId): IDatalayerViewerFactory[] {

        var i = this.getItem(type);
        if (i) {
            return i.viewers.slice();
        }

    }

    getCurrentViewer(type: LayerTypeId): IDatalayerViewerFactory {
        var i = this.getItem(type);
        if (i) {
            return i.current;
        }

    }

    setCurrentViewer(type: LayerTypeId, viewer: IDatalayerViewerFactory): boolean {

        var i = this.getItem(type);

        if (i && i.viewers.find(v => v == viewer)) {
            i.current = viewer;
            return true;
        }

    }



}
